import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import withRouter from '../withRouter';

import axios from 'axios';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Image from 'react-bootstrap/Image';

import {
    MaskedInput
    , HStack
    , Input
    , InputGroup
    , Button
    , Text
    , Loader,
    VStack
} from 'rsuite';

import Logo from '../../images/logo512.png'

import Swal from 'sweetalert2'
import $ from 'jquery';

class LoginPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            content: null,
            loading: false,
            visible: false,
            username: '',
            password: ''
        };
    }

    async componentDidMount() {
        this.onRenderContent({ mode: 'read' })
    }

    promisedSetState = (newState) => {
        return new Promise(resolve => this.setState(newState, resolve));
    };

    handleVisible = async () => {
        await this.promisedSetState({ visible: !this.state.visible })
        await this.onRenderContent({ mode: 'read' })
    }

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {

            this.onConfirm({ mode: 'login' });
        }
    };

    onRenderContent = async ({ mode }) => {
        if (mode === 'read') {
            await this.promisedSetState({ loading: true })

            await this.promisedSetState({
                content: <Row className='mt-4 justify-content-center' style={{ marginLeft: '0.5em', marginRight: '0.5em' }}>
                    <Col lg={4} md={6} xs={12} className='mt-3'>
                        <Row className="justify-content-center">
                            <Col className="text-center">
                                <Image
                                    src={Logo}
                                    rounded
                                    style={{ width: '18%', height: 'auto' }}
                                />
                            </Col>
                        </Row>

                        <Row className='mt-2 justify-content-center'>
                            <Col className="text-center">
                                <Text weight="bold" style={{ fontSize: '1.625rem' }}>ทุนการศึกษามูลนิธิแม่ฟ้าหลวง ในพระบรมราชูปถัมภ์</Text>
                            </Col>
                        </Row>

                        <Row className='mt-3'>
                            <Col>
                                <Card border="light" className='shadow-sm'>
                                    <Card.Header style={{ backgroundColor: '#696969' }}><Text className='text-light'>ลงชื่อเข้าใช้งาน (เฉพาะผู้ดูแลระบบ)</Text></Card.Header>
                                    <Card.Body style={{ marginLeft: '0.5em', marginRight: '0.5em' }}>
                                        <Card.Text style={{ fontWeight: 'bold' }}>
                                            <Row>
                                                <Col>
                                                    <VStack>
                                                        <label>Username</label>
                                                        <Input
                                                            className='tmlU7'
                                                            size='sm'
                                                            onChange={e => this.setState({ username: e })}
                                                        />
                                                    </VStack>
                                                </Col>
                                            </Row>
                                            <Row className='mt-2'>
                                                <Col>
                                                    <VStack>
                                                        <label>Password</label>
                                                        <InputGroup size='lg' inside >
                                                            <Input
                                                                className='N4Uh8'
                                                                type={this.state.visible ? 'text' : 'password'}
                                                                onKeyDown={this.handleKeyPress}
                                                                onChange={e => this.setState({ password: e })} />
                                                            <InputGroup.Button onClick={this.handleVisible}>
                                                                {this.state.visible ? <i className="bi bi-eye"></i> : <i className="bi bi-eye-slash"></i>}
                                                            </InputGroup.Button>
                                                        </InputGroup>
                                                    </VStack>
                                                </Col>
                                            </Row>
                                            <Row className='mt-3'>
                                                <Col className="text-center">
                                                    <Button
                                                        color="green"
                                                        appearance="primary"
                                                        onClick={() => this.onConfirm({ mode: 'login' })}>
                                                        <b>เข้าสู่ระบบ</b>
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Card.Text>
                                    </Card.Body>
                                    <br />
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            })
        }

        await this.promisedSetState({ loading: false })
    }

    Validate = async (params, clss, cond) => {
        try {
            // Simulate an asynchronous operation (e.g., a network request or delay)
            await new Promise(resolve => setTimeout(resolve, 100)); // Simulating a 500ms delay

            if (params == cond) {
                // Add 'required' class if condition is met
                $('.' + clss).addClass("required");

                // Display an alert using SweetAlert
                Swal.fire({
                    title: "กรุณาชื่อผู้ใช้งานและรหัสผ่าน",
                    icon: "warning",
                    timer: 2000,
                    timerProgressBar: true,
                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                });

                return false; // Return false if validation fails
            } else if (params != cond) {
                // Remove 'required' class if condition is not met
                $('.' + clss).removeClass("required");

                return true; // Return true if validation passes
            }
        } catch (error) {
            console.error('Validation error:', error);
            return false; // If something goes wrong, return false as fallback
        }
    };

    onConfirm = async ({ mode }) => {

        const validate = async () => {
            // Start with an array to collect validation promises
            const validationPromises = [
                this.Validate(this.state.username, 'tmlU7', ''),
                this.Validate(this.state.password, 'N4Uh8', ''),
            ];

            // Wait for all validation promises to resolve
            const validationResults = await Promise.all(validationPromises);

            // Return true if all validations are successful (i.e., all are true)
            return validationResults.every(result => result === true);
        };

        if (mode === 'login') {
            if (await validate()) {

                await this.promisedSetState({ loading: true });  // Show loading indicator

                try {

                    const Response = await axios.post(`${process.env.REACT_APP_API}/admin`, {
                        username: this.state.username,
                        password: this.state.password
                    });

                    const data = Response.data;

                    if (data.message === 'LoginSuccessfully') {

                        await this.promisedSetState({ loading: true });

                        const loginData = {
                            status: 'successfully',
                            data: Response.data.user
                        };

                        // Log the login data to localStorage
                        localStorage.setItem('signed', JSON.stringify(loginData));
                        localStorage.setItem('token', Response.data.token);

                        // Optionally update state before redirect
                        await this.promisedSetState({ loading: false });

                        // Redirect to form_apply
                        window.location.href = '/admin';

                    } else if (data.message === 'InvalidPassword') {
                        await this.promisedSetState({ loading: false });  // Stop loading
                        Swal.fire({
                            title: "กรุณาตรวจสอบชื่อผู้ใช้งานหรือรหัสผ่านอีกครั้ง",
                            icon: "warning",
                            timer: 2000,
                            timerProgressBar: true,
                            confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                        });
                    }

                } catch (error) {
                    await this.promisedSetState({ loading: false });  // Stop loading
                    Swal.fire({
                        title: "กรุณาตรวจสอบชื่อผู้ใช้งานหรือรหัสผ่านอีกครั้ง",
                        icon: "error",
                        timer: 2000,
                        timerProgressBar: true,
                        confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                    });
                }
            }
        }
    }

    render() {

        const FullPageLoader = () => (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.8)', // Semi-transparent background
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999 // Ensure it's on top of other content
            }}>
                <Loader content="Loading..." /> {/* Adjust loader component as needed */}
            </div>
        );

        return (
            <>
                {this.state.content}
                {this.state.loading && <FullPageLoader />}
            </>
        );
    }
}

export default withRouter(LoginPage);
